import { render, staticRenderFns } from "./VideoPlayerView.vue?vue&type=template&id=f754d412"
import script from "./VideoPlayerView.vue?vue&type=script&lang=js"
export * from "./VideoPlayerView.vue?vue&type=script&lang=js"
import style0 from "./VideoPlayerView.vue?vue&type=style&index=0&id=f754d412&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports